import React from "react";
import { Observer } from "mobx-react";
import { TimeReportProfile } from "./TimeReportProfile";
import { BookingKitFormProvider } from "./TRKit/use-booking-kit-form-context";
import { BookingProfileStore } from "@bookings/BookingProfile/BookingProfileStore";

export type Props = {
  bookingId: string;
  consultantId: string;
  consultantName: string;
  week: number;
  year: number;
  bookingProfileStore: BookingProfileStore;
  handleRunAutoCreate: () => Promise<boolean>;
  autoCreateBookingKitDisabled: boolean;
};

export const TimeReport = (props: Props) => {
  return (
    <Observer>
      {() => (
        <div>
          <BookingKitFormProvider
            bookingId={props.bookingId}
            consultantId={props.consultantId}
          >
            <TimeReportProfile
              bookingId={props.bookingId}
              consultantId={props.consultantId}
              consultantName={props.consultantName}
              week={props.week}
              year={props.year}
              bookingProfileStore={props.bookingProfileStore}
              handleRunAutoCreate={props.handleRunAutoCreate}
              autoCreateBookingKitDisabled={props.autoCreateBookingKitDisabled}
            />
          </BookingKitFormProvider>
        </div>
      )}
    </Observer>
  );
};
